import React from "react";

const NoPage = () => {
  return <h1 className="no-page inter-font-bold">404</h1>;
};

export default NoPage;
